
<template>
<div class="container-fluid">
     <b-card>
          <treeselect :multiple="true" :options="conceptTree" v-model="selectedThemes" placeholder="Selectionnez un ou plusieurs thèmes"/>
          <b-button id="criteriaButtons" variant="outline-success" @click="find()">Rechercher</b-button>
      </b-card>
       <br>
      <b-card :title="`Résultat de la requête (` + mapListForTable.length + ` cartes)`" class="overflow-auto" v-if="mapListForTable.length != 0">
        <map-table-result v-bind:mapListForTable="mapListForTable"></map-table-result>
      </b-card>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Treeselect from '@riophae/vue-treeselect'
import MapTableResult from './MapTableResult'

export default {
  name: 'thematical-search',
  components: { Treeselect, MapTableResult },
  computed: {
    ...mapGetters({
      mapListForTable: 'getMapsWithThematicCatList'
    })
  },
  methods: {
    find: function () { this.$store.dispatch('findMapsWithThematicCat', this.selectedThemes ) }
  },
  data() {
    return {
      selectedThemes: null,
      conceptTree: [{
          id: 'aaev',
          label: 'Actions, activités des êtres vivants',
          children: [
            {
            id: 'aaevAnimaux',
            label: 'Animaux',
            children: [
              { id: 'aaevAnimauxDomestiques', label: 'Animaux domestiques' },
              { id: 'aaevAnimauxSauvages', label: 'Animaux sauvages' }
            ]
          },
            { id: 'aaevEtreHumain', label: 'Être humain' },
            { id: 'aaevVegetaux', label: 'Végétaux' }
          ]
        },
        {
          id: 'animaux',
          label: 'Animaux',
          children: [
            {
              id: 'animauxDomestiques',
              label: 'Animaux domestiques',
              children: [
                { id: 'animauxDomestiquesBasseCour', label: 'Basse-cour' },
                { id: 'animauxDomestiquesBetesDeSomme', label: 'Bêtes de somme' },
                { id: 'animauxDomestiquesBovins', label: 'Bovins' },
                { id: 'animauxDomestiquesChiensChats', label: 'Chiens, chats' },
                { id: 'animauxDomestiquesOvinsCaprins', label: 'Ovins, caprins' },
                { id: 'animauxDomestiquesPorcins', label: 'Porcins' },
                { id: 'animauxDomestiquesProduitsLaitiers', label: 'Produits laitiers' },
                { id: 'animauxDomestiquesRuches', label: 'Ruches' },
                { id: 'animauxDomestiquesVersSoie', label: 'Vers à soie' },
                { id: 'animauxDomestiquesNsp', label: 'Non spécifique' }
              ]
            },
            {
              id: 'animauxSauvages',
              label: 'Animaux sauvages',
              children: [
                { id: 'animauxSauvagesArachnides', label: 'Arachnides' },
                { id: 'animauxSauvagesInsectesMollusques', label: 'Insectes, mollusques' },
                { id: 'animauxSauvagesMammiferes', label: 'Mammifères' },
                { id: 'animauxSauvagesOiseaux', label: 'Oiseaux' },
                { id: 'animauxSauvagesReptilesPoissonsBatraciens', label: 'Reptiles, poissons, batraciens' },
                { id: 'animauxSauvagesNsp', label: 'Non spécifiques' }
              ]
             },
            { id: 'animauxNsp', label: 'Non spécifique' }
          ]
        },
        {
          id: 'carphys',
          label: 'Caractéristiques physiques',
          children: [
            { id: 'carphysAspectGoutTexture', label: 'Aspect, goût, texture' },
            { id: 'carphysCouleursFormes', label: 'Couleurs, formes' },
            { id: 'carphysQuantite', label: 'Quantité' },
            { id: 'carphysTailleLongueur', label: 'Taille, longueur, heuteur, poids, masse' }
          ]
        },
        {
          id: 'cultures',
          label: 'Culture',
            children: [
            { id: 'culturesArboriculture', label: 'Arboriculture' },
            { id: 'culturesCeralesMoissons', label: 'Céréales, moissons' },
            { id: 'culturesJardin', label: 'Jardin' },
            { id: 'culturesLaboursSemailles', label: 'Labours, semailles' },
            { id: 'culturesOutillages', label: 'Outillages' },
            { id: 'culturesPresFoinsVegTextiles', label: 'Prés, foins, végétaux textiles' },
            { id: 'culturesViticulture', label: 'Viticulture' },
            { id: 'culturesNsp', label: 'Non spécifique' }
          ]
        },
        {
          id: 'etreHumain',
          label: 'Être humain',
          children: [
            { id: 'etreHumainAgeVie', label: 'Âge de la vie' },
            { id: 'etreHumainCaracteresSentimentsJugements', label: 'Caractères, sentiments, jugements' },
            { id: 'etreHumainCorpsHumainSens', label: 'Corps humain, sens' },
            { id: 'etreHumainFamille', label: 'Famille' },
            { id: 'etreHumainMaladiesAffections', label: 'Maladies, affections' },
            { id: 'etreHumainNoms', label: 'Noms de personnes' }
          ]
        },
        {
          id: 'flore',
          label: 'Flore',
          children: [
            { id: 'floreCultivee', label: 'Cultivée' },
            {
              id: 'floreSauvage',
              label: 'Sauvage',
              children: [
                { id: 'floreSauvageAbresForets', label: 'Arbres, forêts' },
                { id: 'floreSauvagePlantesArbustes', label: 'Plantes, arbustes' }
              ]
             },
            { id: 'floreNsp', label: 'Non spécifique' }
          ]
        },
        {
          id: 'habvq',
          label: 'Habitat, vie quotidienne',
          children: [
            { id: 'habvqLingeHabillementCouture', label: 'Linge, habillement, couture' },
            { id: 'habvqMaison', label: 'Maison' },
            { id: 'habvqMobilierUstensilesFeu', label: 'Mobilier, ustensiles, feu' },
            { id: 'habvqNourritureBoissons', label: 'Nourriture, boisson' }
          ]
        },
        {
          id: 'nature',
          label: 'Nature',
          children: [
            { id: 'natureCouleursFormes', label: 'Couleurs, formes' },
            { id: 'natureEspaces', label: 'Espaces' },
            { id: 'natureSolsReliefsMers', label: 'Sols, reliefs, mers, cours d\'eau' },
            { id: 'natureTempsMeteorologique', label: 'Temps météorologique' }
          ]
        },
        {
          id: 'orgps',
          label: 'Organisations, pratiques sociales',
          children: [
            { id: 'orgpsAdministrationsInstitutions', label: 'Administrations, institutions' },
            { id: 'orgpsArtisanatCommerce', label: 'Artisanat, commerce' },
            { id: 'orgpsCheminsTransports', label: 'Chemins, transports' },
            { id: 'orgpsGroupesHumainsRelations', label: 'Groupes humains, relations' },
            { id: 'orgpsJeuxLoisirs', label: 'Jeux, loisirs' },
            { id: 'orgpsNombres', label: 'Nombres' },
            { id: 'orgpsReligionsFetesCroyances', label: 'Religions, fêtes, croyances' },
            { id: 'orgpsTempsChronologique', label: 'Temps chronologique' },
            { id: 'orgpsVillesVillages', label: 'Villes, villages' }
          ]
        },
        {
          id: 'outils',
          label: 'Outils',
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/search/ThematicalSearch.vue